import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo_up2.jpg';
import './Header.css';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false)    // ← menuOpen 정의

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

 const headerStyle = {
  backgroundColor: isScrolled
    ? 'rgba(30, 58, 138, 0.35)'
    : '#1E3A8A',
  // 스크롤 전엔 none, 스크롤 후에도 none
  backdropFilter: 'none',
  WebkitBackdropFilter: 'none',
  transition: 'background-color 0.3s ease'
};

  return (
    <header className="header" style={headerStyle}>
      <div className="logo">
        <a href="http://www.everyoungpeople.com/">
          <img src={logoImage} alt="로고" />
        </a>
      </div>
      
    

      {/* 햄버거 아이콘 (모바일 전용) */}
      <button
        className={`menu-toggle${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen(o => !o)}
        aria-label="메뉴 열기/닫기"
      >
        {/* 간단한 3줄 아이콘 */}
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>

      {/* isOpen 상태에 따라 클래스 추가 */}
      <nav className={`nav${menuOpen ? ' open' : ''}`}>
        <Link to="/"    onClick={() => setMenuOpen(false)}>홈</Link>
        <Link to="/operation"         onClick={() => setMenuOpen(false)}>운영방법</Link>
        <Link to="/anti-aging-habits" onClick={() => setMenuOpen(false)}>저속노화습관</Link>
        <Link to="/program"           onClick={() => setMenuOpen(false)}>프로그램</Link>
      </nav>
    </header>
  );
}